import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { FadeUp, PageHero } from "../components/Reveal";

export default function Collections() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/collections").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <main data-testid="collections-page">
      <PageHero
        eyebrow="Collections"
        title="Designs shaped by Celts, Vikings and Knox"
        sub="Browse Celtic Gold jewellery by the collections and inspirations behind each piece."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((col, i) => (
            <FadeUp key={col.slug} delay={(i % 3) * 0.08}>
              <Link
                to={`/collections/${col.slug}`}
                data-testid={`collection-card-${col.slug}`}
                className="group relative block h-96 overflow-hidden border border-white/5 hover:border-gold/40 transition-colors duration-700"
              >
                <img src={col.image} alt={col.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/35 to-transparent" />
                <div className="absolute bottom-0 p-7">
                  {col.count > 0 && <p className="font-mono text-[10px] text-gold tracking-[0.3em] mb-2">{col.count} pieces</p>}
                  <h2 className="font-serif text-2xl text-ivory group-hover:text-gold transition-colors duration-500">{col.name}</h2>
                  <p className="text-stone-mist text-sm font-light mt-2 line-clamp-2">{col.description}</p>
                  <span className="inline-flex items-center gap-2 text-gold text-[11px] uppercase tracking-[0.25em] mt-5">
                    Explore Collection <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </section>
    </main>
  );
}
